import { useMediaQuery } from "@mui/material";
import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const MobileMenuContext = createContext(null);

/*
Makes sure footer opens right language menu
*/
export const MobileMenuProvider = ({ children }) => {
    const location = useLocation();
    const isMobileBar = useMediaQuery(`(max-width:1150px)`);
    const [langOpen, setLangOpen] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setOpen(false);
    }, [location.pathname]);

    const setOpenInternal = (val) => {
        setOpen(val);
        if (!val) {
            setLangOpen(val);
        }
    }

    const setLangOpenInternal = (val) => {
        setLangOpen(val);
        if (val && !open) {
            setOpen(val);
        }
    }

    const languageMenuMobileProps = {
        setOpenExtern: setLangOpenInternal,
        openExtern: langOpen,
    }

    return (
        <MobileMenuContext.Provider value={{
            langOpen, setLangOpen, open, setOpen,
            languageMenuMobileProps, setOpenInternal, setLangOpenInternal,
            isMobileBar
        }}>
            {children}
        </MobileMenuContext.Provider>
    );
};

export const useMobileMenu = () => useContext(MobileMenuContext);